<template>
  <div align="Left">
    <md-card id="screenings" class="md-with-hover" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">visibility</i>
        </div>
        <h4 class="title">Screenings On-Hold [Technician]</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-right" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchTxt" />
            </md-field>
          </div>

          <!-- SPACER -->
          <!-- <div class="md-layout-item md-size-10"></div> -->
        </div>
        <hr v-if="!isLoading" />
      </md-card-header>

      <md-card-content style="padding-top: 0px;" v-if="!isLoading">
        <md-table
          v-model="screeningsDataSet"
          :md-fixed-header="false"
          class="table-shopping table-striped table-hover"
          @md-selected="getSelected"
          @click.native="labelSort($event, false)"
        >
          <md-table-row>
            <md-table-empty-state
              :md-description="`No screenings found for this time frame or search criteria`"
              md-label="No screenings found"
            />
          </md-table-row>
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
            @click="gotoEval(item)"
            :class="{ isEDIT: String(item.status).toLowerCase() === 'edit' }"
          >
            <md-table-cell style="height: 52px;">
              <md-button
                v-if="String(item.status).toLowerCase() === 'edit'"
                class="md-info md-sm md-grey"
                style="min-width: 60px;"
                @click.stop="editScreening(item)"
                disabled
                >Edit</md-button
              >
              <md-button
                v-else
                class="md-warning md-sm md-grey"
                style="min-width: 60px;"
                @click.stop="releaseHold(item)"
                disabled
                >Release</md-button
              >
            </md-table-cell>

            <md-table-cell v-if="FL" md-label="name">
              <span style="font-size: .99em; font-weight: 500;">{{ item.firstName }}</span> <br />
              <small style="font-size: .83em; color: darkgreen; "> {{ item.Email }} </small>
            </md-table-cell>
            <md-table-cell v-else md-label="name"
              >{{ item.lastName }} <span style="font-size: .99em; font-weight: 500;">{{ item.firstName }}</span> <br />
              <small style="font-size: .83em; color: darkgreen; "> {{ item.Email }} </small>
            </md-table-cell>
            <!-- <md-table-cell md-label="status":class="getClass(item)">{{ item.status }}</md-table-cell> -->

            <md-table-cell md-label="device / screening">
              <span>{{ item.Device }}</span
              ><br />
              <small style="color: green;"> {{ item.packageID.slice(0, 11).toUpperCase() }}</small>
            </md-table-cell>

            <md-table-cell md-label="technician">{{ item.Technician }}</md-table-cell>
            <md-table-cell md-label="holder">{{ item.DoctorName }}</md-table-cell>
            <md-table-cell md-label="screen date/time"
              >{{ item.Date.split("T")[0] }} - {{ item.Date.slice(-8, -3) }}</md-table-cell
            >
            <md-table-cell md-label="duration">
              <small>{{ item.Duration }} &nbsp; minutes</small>
            </md-table-cell>

            <md-table-cell>
              <md-button
                v-if="String(item.status).toLowerCase() === 'edit'"
                style="width: 35px; margin: 0px;"
                @click.stop="handleClose(item)"
                class="md-grey"
                disabled
              >
                <md-icon
                  style="margin-left: 0px !important; margin-right: 30px !important; padding-bottom: 8px; padding-right: 5px;"
                  >close</md-icon
                >
              </md-button>
              <md-button
                v-else
                style="width: 35px; margin: 0px;"
                @click.stop="handleDelete(item)"
                class="md-grey"
                disabled
              >
                <md-icon
                  style="margin-left: 0px !important; margin-right: 30px !important; padding-bottom: 8px; padding-right: 5px;"
                  >delete</md-icon
                >
              </md-button>
            </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <div class="table table-stats">
          <div class="text-right">
            <hr />
            <div class>
              <p class="card-category">Showing {{ total }} entries</p>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import Swal from "sweetalert2"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  components: {
    loader
  },
  data() {
    return {
      payload: {
        kioskID: "0-000",
        hold: true
      },
      status: false,
      isLoading: false,
      sortBy: "name",
      sortDirection: "ASC",
      search: "",
      FL: true,
      orderAsc: false,
      API_SERVICE: process.env.VUE_APP_URL,
      selected: {},
      searchTxt: "",
      currentSort: "name",
      currentSortOrder: "asc",
      footerTable: ["First", "Last", "Email", "Tech", "Globe", "Date"],
      searchQuery: "",
      propsToSearch: ["first", "last", "email", "date"],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    }
  },

  computed: {
    ...mapGetters(["screenings", "screeningID"]),
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below

    screeningsDataSet() {
      // return this.screenings;

      if (this.searchTxt) {
        var self = this
        var restul_A = this.screenings.filter(function(a) {
          // Convert null values to '' so toLowerCase() will work on compare
          a.firstName = a.firstName ? a.firstName : ""
          a.lastName = a.lastName ? a.lastName : ""
          a.Email = a.Email ? a.Email : ""
          a.Technician = a.Technician ? a.Technician : ""
          a.Device = a.Device ? a.Device : ""
          a.DoctorName = a.DoctorName ? a.DoctorName : ""
          a.packageID = a.packageID ? a.packageID : ""
          a.Date.split("T")[0] = a.Date.split("T")[0] ? a.Date.split("T")[0] : ""

          return (
            a.firstName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.lastName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Email.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Technician.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Device.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.DoctorName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.packageID.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Date.split("T")[0].includes(self.searchTxt.toLowerCase())
          )
        })
        return restul_A
      } else {
        return this.screenings
      }
    },

    total() {
      return this.screeningsDataSet.length > 0 ? this.screeningsDataSet.length : this.screeningsDataSet.length
    }
  },
  watch: {
    //NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
    //@param value of the query
    searchQuery(value) {
      let result = this.tableData
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    }
  },
  mounted: function() {
    this.enableInterceptor();
    this.$store.dispatch("loadScreenings", this.payload)
    this.tableData = this.screenings
  },

  methods: {
    enableInterceptor() {
      this.axiosInterceptor = window.axios.interceptors.request.use(
        config => {
          this.isLoading = true
          return config
        },
        error => {
          this.isLoading = false
          return Promise.reject(error)
        }
      )

      window.axios.interceptors.response.use(
        response => {
          this.isLoading = false
          return response
        },
        function(error) {
          this.isLoading = false
          return Promise.reject(error)
        }
      )
    },

    disableInterceptor() {
      window.axios.interceptors.request.eject(this.axiosInterceptor)
    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.sortBy = sort

      // alert(sort)

      if (sort == this.sortBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderAsc = true
      }

      switch (sort) {
        case "name":
          this.screensByLastfirst(this.orderAsc)
          break

        case "globe":
          this.screensByGlobe(this.orderAsc)
          break

        case "technician":
          this.screensByTechnician(this.orderAsc)
          break

        case "holder":
          this.screensByHolder(this.orderAsc)
          break

        case "screen date/time":
          this.screensByDateTime(this.orderAsc)
          break

        default:
          return null
      }
    },
    releaseHold(i) {
      if (localStorage.getItem("ongoingScreenings")) {
        var ongoingScreenings = JSON.parse(localStorage.getItem("ongoingScreenings"))
        let filteredScreenings = ongoingScreenings.filter(id => id != i.generate)
        localStorage.setItem("ongoingScreenings", JSON.stringify(filteredScreenings))
        localStorage.removeItem(i.generate)
      }
      this.updtHoldStat(i, "New")
      this.deleteRow(i)
      this.$forceUpdate()
    },

    deleteItem(i) {
      var vm = this
      const config = { headers: { "Content-Type": "application/json" } }
      const url = this.API_SERVICE + "/screening/"
      const data = {
        pkgid: i.packageID,
        field: "isdelete",
        data: "1"
      }
      window.axios
        .patch(url, data, config)
        .then(function(response) {
          vm.status = response.data
        })
        .catch(function(error) {
          vm.status = "An error occurred: " + error
          console.log(vm.status)
        })
      this.deleteRow(i)
    },

    updtHoldStat: function(i, s) {
      var vm = this
      var newStatus = s
      var screening = i.packageID
      var reader = sessionStorage.getItem("userID")

      const config = { headers: { "Content-Type": "application/json" } }
      const url = this.API_SERVICE + "/screening/" + screening + "/" + newStatus + "/" + reader //[screening-status]
      const data = null

      //console.log("***@ axios.put ***", url);
      window.axios
        .put(url, data, config)
        .then(function(response) {
          vm.status = response.data
        })
        .catch(function(error) {
          vm.status = "An error occurred: " + error
          console.log(vm.status)
        })
    },

    screensByLastfirst(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.lastName > b.lastName ? 1 : -1
        } else {
          return a.lastName < b.lastName ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },

    screensByDateTime(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return new moment(a.Date).format("YYYYMMDD") > new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        } else {
          return new moment(a.Date).format("YYYYMMDD") < new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },

    screensByTechnician(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.Technician > b.Technician ? 1 : -1
        } else {
          return a.Technician < b.Technician ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },

    screensByHolder(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.DoctorName > b.DoctorName ? 1 : -1
        } else {
          return a.DoctorName < b.DoctorName ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },

    screensByGlobe(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.Device > b.Device ? 1 : -1
        } else {
          return a.Device < b.Device ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },

    refreshPage() {
      this.$router.go()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    getSelected(item) {
      this.selected = item
    },

    gotoEval(item) {
      this.selected = item
      sessionStorage.setItem("screeningID", item.packageID)
      sessionStorage.setItem("storageID", item.screenID)
      sessionStorage.setItem("OrgID", item.orgID)
      sessionStorage.setItem("OrgCode", item.orgCode)
      sessionStorage.setItem("OrgBusiness", item.orgBusiness)
      sessionStorage.setItem("patientUserID", item.patientUserID)

      if (item.status === "Ongoing") {
        localStorage.setItem("Ongoing", "true")
      } else {
        localStorage.setItem("Ongoing", "false")
      }
      this.$router.push("/portal/technician/evalviewonly")
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },
    handleLike(item) {
      ;({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success"
      })
    },
    handleEdit(item) {
      Swal.fire({
        title: `You want to edit ${item.name}`,
        buttonsStyling: false,
        confirmButtonClass: "md-button md-info"
      })
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `Flag this screening as DELETED`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteItem(item)
          this.deleteRow(item)
          Swal.fire({
            title: "Deleted!",
            text: `Screening moved to recycle bin`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          })
        }
      })
    },

    deleteRow(item) {
      let indexToDelete = this.screenings.findIndex(tableRow => tableRow.ID === item.ID)
      if (indexToDelete >= 0) {
        this.screenings.splice(indexToDelete, 1)
      }
    },

    editScreening(item) {
      this.gotoEval(item)
    },

    handleClose(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `Close this screening without editing?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, close it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.updtHoldStat(item, "Closed")
          Swal.fire({
            title: "Closed!",
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          }).then(() => {
            // this.$router.go();
            this.$router.push("/portal/technician/reports")
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white;
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-button.md-info,
.md-button.md-info:hover,
.md-button.md-info:focus,
.md-button.md-info:active,
.md-button.md-info.active,
.md-button.md-info:active:focus,
.md-button.md-info:active:hover,
.md-button.md-info.active:focus,
.md-button.md-info.active:hover,
.open > .md-button.md-info.dropdown-toggle,
.open > .md-button.md-info.dropdown-toggle:focus,
.open > .md-button.md-info.dropdown-toggle:hover {
  background-color: #0277bd !important;
}

.table-striped tbody > tr[data-v-68fc65d4]:nth-of-type(odd) {
  background-color: #edf2f7;
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

.md-table-cell {
  padding: 0px 5px;
}

.md-icon {
  margin-left: 24px !important;
}

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.isEDIT {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
  background-color: #e6ffe6 !important;
}

.md-table-row.isEDIT:hover {
  background-color: #ccffcc !important;
}
.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}
</style>
